<template>
  <!-- <div class="sill"></div> -->
  <div class="flex-x-center">
    <div class="con-register">
      <div class="two-menu">
        <el-menu
          active-text-color="#f56c6c"
          :default-active="activeIndexTwo"
          class="el-menu-demo"
          mode="horizontal"
        >
          <el-menu-item @click="routeHop('/home')" index="1" class="basics">
            基本资料</el-menu-item
          >
          <el-menu-item
            @click="routeHop('/accountSecurity')"
            index="2"
            class="basics"
          >
            账户安全</el-menu-item
          >
        </el-menu>
        <identify_off v-if="initProject.identify_open == 0 || !initProject.identify_open" />
        <identify_open v-if="initProject.identify_open == 1" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import identify_off from "./homeControl/identify_off.vue";
import identify_open from "./homeControl/identify_open.vue";

export default {
  components: {
    identify_off,
    identify_open,
  },
  computed: {
    ...mapState(useMainStore, {
      userInfo: "getUserInfo",
      userCertInfo: "getUserCertInfo",
      initProject: "getInitProject",
    }),
  },
  data() {
    return {
      activeIndex: "4",
      activeIndexTwo: "1",
      dialogLoadimg: false,
      name: "",
    };
  },
  mounted() {},
  methods: {
    routeHop(url) {
      this.$router.push(url);
    },
    ...mapActions(useMainStore, {
      token: "updateToken",
      getCertInfo: "updateUserCertInfo",
    }),
  },
};
</script>


<style scoped>
.confirm {
  width: 80px;
  height: 40px;
  border-radius: 4px;
  background-color: rgb(231, 228, 228);
  border: none;
  margin: 40px 0px 0px 0px;
}

.id-text {
  font-size: 16px;
  color: rgb(39, 36, 36);
  margin-top: 30px;
  margin-left: 10px;
  font-weight: 300;
}

.avatar-uploader-icons {
  font-size: 28px;
  color: black;
  width: 300px;
  height: 120px;
  line-height: 100px;
  text-align: center;
}

.load-boxid {
  background-color: #f6f4f4;
  color: rgb(255, 255, 255);
  border: 1px rgb(216, 207, 207) dotted;
  margin: 30px 10px;
  height: 200px;
  border-radius: 4px;
  width: 300px;
}

.inline-input {
  width: 300px;
}

.load-box {
  background-color: #f6f4f4;
  color: rgb(255, 255, 255);
  border: 1px rgb(216, 207, 207) dotted;
  margin: 0px 10px;
  height: 200px;
  width: 400px;
  border-radius: 4px;
}

.load-imgtext {
  color: black;
  margin: 20px;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 1px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: black;
  width: 300px;
  height: 120px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.load-img {
  margin-left: 10%;
}

.basics {
  font-size: 16px;
  color: black;
}

.sill-t {
  width: 1px;
  height: 30px;
  background-color: rgb(239, 232, 232);
  margin-top: 10px;
}

.sill {
  width: 100%;
  height: 1px;
  background-color: rgb(239, 232, 232);
  margin: 20px 0px;
}

.applyicon-fontsize {
  font-size: 25px;
}

.title-fontsize {
  font-size: 20px;
  height: 60px;
}

.line-messages {
  margin-top: 20px;
}

.line-message {
  margin-top: 60px;
}

.message-input {
  width: 300px;
}

.message {
  color: rgb(145, 135, 135);
  width: 80px;
  font-size: 16px;
  font-weight: 300;
}

.detail-linehead {
  line-height: 20px;
  letter-spacing: 1px;
}

.bule-detail {
  color: #539fea;
  font-weight: 300;
}

.photo-detail-red {
  color: red;
  font-weight: 300;
}

.explain {
  margin-top: 20px;
}

.photo-detail {
  color: rgb(145, 135, 135);
  font-weight: 300;
  margin-top: 10px;
}

.photo-re {
  font-size: 10px;
  font-weight: 500;
}

.photo-requirements {
  margin-left: 60px;
}

.person-profile {
  margin-top: 20px;
}

.two-menu {
  margin-top: 30px;
  font-weight: 500;
}

.notice {
  margin: 0px 30px;
  color: #539fea;
  font-weight: 600;
  font-size: 19px;
}

.off {
  color: #539fea;
  font-size: 18px;
}

/* .two-icon {
  margin: 20px 40px;
} */
.load-nows {
  color: #539fea;
  border: none;
  font-size: 16px;
}

.load-now {
  /* margin-right: 30px; */
  margin-top: 15px;
  color: #000;
}

.register {
  font-size: 20px;
  margin-top: 60px;
}

.con-register {
  width: 82%;
  /* height: 780px; */
  background-color: #fff;
  margin-top: 30px;

  border-radius: 4px;
}

/* .title-img {
  width: 40px;
  height: 40px;
  margin: 10px 20px 10px 50px;
  border-radius: 30px;
} */
/* .re-bigbox {
  background-color: #f0f1f1;
  width: 80%;
  height: 900px;
  min-width: 800px;
  /* margin-top: 40px; */
/* border-radius: 10px; */
/* } */
.re-title {
  height: 10%;
  font-size: 18px;
  font-weight: 500;
  color: #539fea;
}
</style>
